import "./Footer.scss";
import { Image, WhiteSpace } from "../supports";
import ContentButton from "../buttons/ContentButton";

const Footer = () =>{
    return(
        <div id="footer"> 
        <br/>
        <Image src="/images/contact-logo.png" height="100"/>
        <br/>
        <a href="https://www.youtube.com/@marsgamemods">https://www.youtube.com/@marsgamemods</a>
     

        <WhiteSpace height="50"/>
        <br/>

        <WhiteSpace height="50"/>
            <div className="footer-text">// © Autonomous Works // Mars Gamemods</div>
            
            <WhiteSpace height="10"/>
            <disclaimer> Original source by Xform Games. Additional distribution by LegacyShockwave.</disclaimer>

        </div>
        
    );
};

export default Footer;
